EC.formiecsrf = function () {

  'use strict';

  function init() {
    // Fetch the form we want to deal with
    const forms = document.querySelectorAll('.fui-form');
    if (forms) {
      forms.forEach(($form) => {
        // Find the CSRF token hidden input, so we can replace it
        const $csrfInput = $form.querySelector('input[name="CRAFT_CSRF_TOKEN"]');

        const formHandle = $form.querySelector('input[name="handle"]');
        // Fetch the new tokens for the form and replace the captcha inputs
        fetch(`/actions/formie/forms/refresh-tokens?form=${formHandle.value}`)
          .then(result => result.json())
          .then(result => {
            // Update the CSRF token and captchas.
            // Use `csrf.input` for convenience
            $csrfInput.value = result.csrf.token;
            // Find the JavaScript captcha hidden input, so we can update it
            if (result.captchas && result.captchas.javascript) {
              // JavaScript captcha
              const jsCaptcha = result.captchas.javascript;
              $form.querySelector(`input[name="${jsCaptcha.sessionKey}"]`).value = jsCaptcha.value;
            }
            // Find the Duplicate captcha hidden input, so we can update it
            if (result.captchas && result.captchas.duplicate) {
              // Duplicate captcha
              const duplicateCaptcha = result.captchas.duplicate;
              $form.querySelector(`input[name="${duplicateCaptcha.sessionKey}"]`).value = duplicateCaptcha.value;
            }
            // Update the form's hash (if using Formie's themed JS)
            if ($form.form && $form.form.formTheme) {
              $form.form.formTheme.updateFormHash();
            }
          });

        $form.addEventListener('onAfterFormieSubmit', (e) => {
          e.preventDefault();

          if (e.detail.nextPageId) {
            return;
          }

          const response = e.detail;
          if (response.success) {

            let eventName = '';
            let virtualPageUrl = '';
            let virtualPageTitle = '';
            const formHandleValue = formHandle.value;

            switch (formHandleValue) {
              case 'contactForm':
                eventName = 'VirtualSubmissionPage';
                virtualPageUrl = '/enquiry-success';
                virtualPageTitle = 'Successful Submission';
                break;
              case 'newsletter':
                eventName = 'newsletterForm';
                virtualPageUrl = '/newsletter-success';
                virtualPageTitle = 'Successful Newsletter Submission';
                break;
              default:
                return false;
            }

            window.dataLayer = window.dataLayer || [];

            dataLayer.push({
              event: eventName,
              virtualPageURL: virtualPageUrl,
              virtualPageTitle: virtualPageTitle
            });
          }
        });

      });
    }
  }

  return {
    init: init
  };

}();
